<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Recherche Catégorie</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Entité :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="entite"
        :options="entiteLibelles"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Secteur :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="secteur"
        :options="secteurLibelles"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="sauvegarder"> Sauvegarder </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="categories"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cle"
          :paginator="true"
          showGridlines 
          :rows="10"
          sort-field="genre"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} catégories"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="genre"
            header="Genre"
            :sortable="true"
        ></Column>
        <Column
                field="nature"
                header="Nature"
                :sortable="true"
        ></Column>
        <Column
            field="type"
            header="Type"
            :sortable="true"
        ></Column>
        <Column
            field="categorie"
            header="Catégorie"
            :sortable="true"
        ></Column>
        <Column v-for="col of regroupementsToShow" :key="col.field" :field="col.field" :header="col.header">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col center">
                <Checkbox v-model="matriceCheckboxes[findCategorie(data)][findRegroupement(field)]" :binary="true" @change="saveChange(data, field)"/>
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Catégorie Regroupement");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('pilotage/rechercherListeEntiteAction')
    .then((res) => {
        this.entiteLibelles = res.data;
        this.entite = 2;
        this.secteur = 231;
    });
    let libelle = {};
    libelle.valeur = null;
    this.isRechercheDataLoading = true;
    this.$store.dispatch("pilotage/rechercherRegroupementAction", libelle).then((res) => {
      this.regroupements = res.data;
      this.isRechercheDataLoading = false;
    });
  },
  data() {
    return {
      entiteLibelles : [],
      entite: null,
      secteur: null,
      categories: [],
      isRechercheDataLoading: false,
      regroupementsToShow: [],
      matriceCheckboxes: null,
      changesToSave: []
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      secteurLibelles: "pilotage/secteurLibelles",
      regroupements: "pilotage/regroupements"
    }),
  },
  methods: {
    sauvegarder(){
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/sauvegarderCategoriesRegroupementAction", this.changesToSave).then(() => {
        let libelle = {};
        libelle.valeur = null;
        this.$store.dispatch("pilotage/rechercherRegroupementAction", libelle).then((res) => {
          this.regroupements = res.data;
          this.rechercher();
          this.$toast.add({
            severity:'success',
            summary: 'Recherche de catégorie',
            detail:'Les liens ont été sauvegardés',
            life: 6000
          });
        });
      })

    },
    saveChange(data, field){
      let value = this.matriceCheckboxes[this.findCategorie(data)][this.findRegroupement(field)];
      let lienRegroupement = {};
      lienRegroupement.isActive = value;
      lienRegroupement.categorie = data.cle;
      lienRegroupement.regroupement = this.regroupements.find(rg => (rg.description == field)).cle;
      let indexToRemove = -1;
      //on va voir si un enregistrement existe pour cette combinaison
      for(let i = 0; i < this.changesToSave.length; i++){
        if(this.changesToSave[i].categorie == lienRegroupement.categorie && this.changesToSave[i].regroupement == lienRegroupement.regroupement){
          indexToRemove = i;
        }
      }
      //si un enregistrement existe, on fait juste le retirer, ce qui inverse ce qui était déjà là
      if(indexToRemove != -1){
        this.changesToSave.splice(indexToRemove, 1);
      //si aucun enregistrement existe, on l'ajoute.
      }else{
        this.changesToSave.push(lienRegroupement);
      }
    },
    findCategorie(data){
      for(let i = 0; i < this.matriceCheckboxes.length; i++){
        if(this.matriceCheckboxes[i][0] == data.cle){
          return i;
        }
      }
      return -1;
    },
    findRegroupement(field){
      let currentRegroupement = this.regroupements.find(rg => (rg.description == field));
      return this.matriceCheckboxes[0].indexOf(currentRegroupement.cle);
    },
    rechercher() {
      if(this.regroupementsToShow.length != 0){
        this.categories = [];
        this.isRechercheDataLoading = true;

        let libelleRecherche = {};
        libelleRecherche.valeur = this.entite;
        libelleRecherche.enfant = {};
        libelleRecherche.enfant.code = 'Genre';
        libelleRecherche.enfant.enfant = {};
        libelleRecherche.enfant.enfant.code = 'Nature';
        libelleRecherche.enfant.enfant.enfant = {};
        libelleRecherche.enfant.enfant.enfant.code = 'Type';
        libelleRecherche.enfant.enfant.enfant.enfant = {};
        libelleRecherche.enfant.enfant.enfant.enfant.code = 'Categorie';

        this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
          this.isRechercheDataLoading = false;
          res.data.libelles.forEach((currentEntite) => {
            currentEntite.tableValeur.libelles.forEach((currentGenre) => {
              currentGenre.tableValeur.libelles.forEach((currentNature) => {
                currentNature.tableValeur.libelles.forEach((currentType) => {
                  currentType.tableValeur.libelles.forEach((currentCategorie) => {
                    let currentCategorieComplete = {};
                    currentCategorieComplete.genre = currentGenre.tableValeur.description;
                    currentCategorieComplete.nature = currentNature.tableValeur.description;
                    currentCategorieComplete.type = currentType.tableValeur.description;
                    currentCategorieComplete.categorie = currentCategorie.tableValeur.description;
                    currentCategorieComplete.cle = currentCategorie.tableValeur.cle;
                    this.categories.push(currentCategorieComplete)
                  })
                })
              })
            })
          })
          this.calculerMatriceCheckboxes();
        });
      }else {
        this.$toast.add({
          severity:'error',
          summary: 'Recherche de catégorie',
          detail:'Le secteur ne contient aucun regroupement',
          life: 6000
        });
      }
    },
    calculerMatriceCheckboxes() {
      if(this.categories != null && this.regroupementsToShow != null && this.categories.length > 0 && this.regroupementsToShow.length > 0){
        this.matriceCheckboxes = new Array(this.categories.length + 1);
        for (let i = 0; i < this.categories.length; i++) {
          this.matriceCheckboxes[i + 1] = new Array(this.regroupementsToShow.length + 1);
          this.matriceCheckboxes[i + 1][0] = this.categories[i].cle
        }
        let regroupementsId = new Array(this.regroupementsToShow.length + 1);
        for (let j = 0; j < this.regroupementsToShow.length; j++) {
          regroupementsId[j + 1] = this.regroupementsToShow[j].cle
        }
        this.matriceCheckboxes[0] = regroupementsId;

        for(var currentCategoriePos = 1; currentCategoriePos < this.matriceCheckboxes.length; currentCategoriePos++) {
          for(var currentRegroupementPos = 1; currentRegroupementPos < this.matriceCheckboxes[0].length; currentRegroupementPos++) {
            let currentCategorie = this.matriceCheckboxes[currentCategoriePos][0];
            let currentRegroupement = this.regroupements.find(rg => (rg.cle == this.matriceCheckboxes[0][currentRegroupementPos]));
            this.matriceCheckboxes[currentCategoriePos][currentRegroupementPos] = false;
            currentRegroupement.categories.forEach(categorieDuRegroupement => {
              if(categorieDuRegroupement == currentCategorie){
                this.matriceCheckboxes[currentCategoriePos][currentRegroupementPos] = true;
              }
            })
          }
        }
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
  watch: {
    secteur: function(value) {
      if(value != null){
        this.regroupementsToShow = [];
        if(this.regroupements.length > 0){
          this.regroupements.forEach(regroupement => {
            if(value == regroupement.secteur){
              let newCol = {};
              newCol.field = regroupement.description;
              newCol.header = regroupement.description;
              newCol.cle = regroupement.cle;
              newCol.categories = regroupement.categories;
              this.regroupementsToShow.push(newCol);
            }
          })
          this.calculerMatriceCheckboxes();
        }
      }
    }
  }
}
</script>
